import { render, staticRenderFns } from "./CreationPage.vue?vue&type=template&id=cfee8786"
import script from "./CreationPage.vue?vue&type=script&lang=js"
export * from "./CreationPage.vue?vue&type=script&lang=js"
import style0 from "./CreationPage.vue?vue&type=style&index=0&id=cfee8786&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports